module.exports = __webpack_public_path__ + "static/Interstellar-602922c04d65731ff8b2ea5e8f1173e1.svg";